import { useQuery } from '@apollo/client';
import { LoginRuleUserPoolFieldsPayload } from 'src/components/login-rules/form/login-rule-criteria/types';
import {
  LoginRuleUserPoolFieldsDocument,
  LoginRuleUserPoolFieldsQuery,
} from 'src/graphql/generated/graphql';

export const useLoginRuleUserPoolFields = () => {
  const { data, loading } = useQuery<LoginRuleUserPoolFieldsQuery>(
    LoginRuleUserPoolFieldsDocument,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  return {
    data: {
      certificates: data?.lmsCertificates.records,
      // companyNames: data?.loginRuleUserPoolCompanyNames,
      companyTypes: data?.loginRuleUserPoolCompanyTypes,
      countries: data?.loginRuleUserPoolCountries,
      fieldOffices: data?.loginRuleUserPoolLocales,
      managementRoles: data?.loginRuleUserPoolManagementRoles,
      programLevels: data?.loginRuleUserPoolProgramLevels,
      programs: data?.loginRuleUserPoolPrograms,
      // userDirectoryIds: data?.loginRuleUserPoolUserDirectoryIds,
      userGroups: data?.loginRuleUserPoolUserGroups,
    } as LoginRuleUserPoolFieldsPayload,
    loading,
  };
};
